import { useEffect } from "react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { api, errMsg, fmtDT, lim } from "../lib/api";
import { StatusBadge, Empty } from "./common";

export default function ApprovalQueue({ items, reload, admin = false }) {
  const live = (items || []).some((r) => ["queued", "approved", "fulfilling"].includes(r.status));
  useEffect(() => {
    if (!live) return undefined;
    const t = setInterval(reload, 10000);
    return () => { clearInterval(t); };
  }, [live]); // eslint-disable-line react-hooks/exhaustive-deps
  const act = async (r, action) => {
    if (action === "unstick" && !window.confirm(`Cancel ${r.rep_name}'s stuck pull? Their leads and texts are refunded and they can request again.`)) return;
    try {
      const res = await api.post(`/rep-requests/${r.id}/${action}`, {});
      toast.success(action === "unstick" ? "Pull cancelled — nothing charged, rep can request again" : res.data?.status ? `Request ${res.data.status.replace(/_/g, " ")}` : "Done");
      reload();
    } catch (e) { toast.error(errMsg(e)); }
  };
  if (!items?.length) return <Empty text="No rep requests." />;
  return (
    <div className="overflow-x-auto">
      <table className="dt" data-testid="approval-queue">
        <thead><tr><th>Rep</th><th>Day</th><th className="num">Allowance</th><th className="num">Received today</th><th className="num">Requested</th><th className="num">Filled</th><th>Status</th><th /></tr></thead>
        <tbody>{items.map((r) => (
          <tr key={r.id} data-testid={`request-row-${r.id}`}>
            <td className="font-medium">{r.rep_name}</td><td className="mono text-xs">{r.local_date}<div className="text-[10px] text-zinc-400">{fmtDT(r.created_at)}</div></td>
            <td className="num">{lim(r.rep_allowance?.allowance)}</td><td className="num">{r.rep_allowance?.used ?? 0}</td>
            <td className="num">{r.requested}</td><td className="num">{r.fulfilled ?? "—"}</td>
            <td><StatusBadge s={r.status} testid={`request-status-${r.id}`} />{r.note && <div className="text-[10px] text-amber-700">{r.note}</div>}</td>
            <td className="text-right whitespace-nowrap space-x-1">
              {["approved", "waiting_inventory"].includes(r.status) && <Button size="sm" variant="outline" onClick={() => act(r, "distribute")} data-testid={`request-distribute-${r.id}`}>Distribute</Button>}
              {admin && r.status === "fulfilling" && <Button size="sm" variant="outline" onClick={() => act(r, "unstick")} data-testid={`request-unstick-${r.id}`}>Unstick</Button>}
            </td>
          </tr>))}
        </tbody>
      </table>
    </div>
  );
}
